module.exports = "<button type=\"button\" class=\"btn btn-primary waves-effect waves-light btn-sm\" ng-click=\"$ctrl.openPopup()\">{{'License_ManageLicense' | translate}}</button>"


//////////////////
// WEBPACK FOOTER
// ./components/popups/license-popup/button/license-button.html
// module id = 1098
// module chunks = 0